import { useState, useEffect } from "react";
import Users from "./Users";
import Disbursed from "./Disbursed";
import Aggregator from "./Aggregator";
import Sanction from "./Saction";
import CustomDateFilter from "../common/CustomDateFilter";
// import StatsComponent from "../common/StatsComponent";
import CustomStepper from "../common/CustomStepper";
import AreaChart from "../common/AreaChart";
import BarMixedCharts from "../common/BarChart";
import LeadConversionStat from "./LeadConversionStat";
import moment from "moment";
import Loader from "../../../../presentationals/Loader/Loader.component";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import {
  Zap,
  IndianRupee,
  FileText,
  BadgeCheck,
  Users as UsersIcon,
  TrendingUp,
  ArrowDownCircle,
  XCircle,
  ChevronLeft,
} from "lucide-react";
import {

  getApicostSummaryByFilters,
  getApicostSummaryHitsByFilters,
  getApiHitTrendByDataRangeApiId,
  getThirdPartyApiListByData,
  getLeadDisbursmentFunnelByDaterange,
  getApiOverviewLeadJourneyFunnelByDateRange,
  getApiOverviewLeadLeakageInsightsByDateRange,
  getThirdPartyApiListcategoryWiseByData,
} from "../ActionCreator";
import { getThirdParyHitData } from "../../../Admin/AdminActionCreator.component";
import MainApiComponent from "../../../Admin/DashboardAndReports/apiTab";
import BarChartsMain from "../common/BarChartsMain";
import LeakageInsights from "./LeakageInsights";
import LeadFunnel from "./LeadFunnel";
import DateFilterSelect from "../../../../CustomDatePicker/DateFilterSelect";
import { CASHBRIDGE_LIKE, CHECK_COMPANY_TENANT } from "../../../../../layouts/MainTenantconfig";

const getStatusCount = (stats = [], statusName) => {
  return stats.find((item) => item.status === statusName)?.usersCrossed ?? "-";
};

const customMargin = window.innerWidth > 1800 ? "70px" : "50px";

const statsConfig = {
  "Total API Hits": {
    icon: Zap,
    color: "#F59E0B",
    bg: "#FEF3C7",
  },
  "Total API Cost": {
    icon: IndianRupee,
    color: "#16A34A",
    bg: "#DCFCE7",
  },

  "Avg Cost per Loan Applied": {
    icon: FileText,
    color: "#7C3AED",
    bg: "#EDE9FE",
  },
  "Cost Per Loan Approved": {
    icon: BadgeCheck,
    color: "#0284C7",
    bg: "#E0F2FE",
  },
  "Avg Cost Per Customer": {
    icon: UsersIcon,
    color: "#2563EB",
    bg: "#DBEAFE",
  },
  "Success Rate": {
    icon: TrendingUp,
    color: "#F97316",
    bg: "#FFEDD5",
  },
  "Avg Cost per Loan Disbursed": {
    icon: ArrowDownCircle,
    color: "#EC4899",
    bg: "#FCE7F3",
  },
  "Failure Rate": {
    icon: XCircle,
    color: "#7C3AED",
    bg: "#EDE9FE",
  },
  // "Total API Hits Change": {
  //   icon: UserPlus,
  //   color: "#F59E0B",
  //   bg: "#FEF3C7",
  // },
  // "Total API Cost Change": {
  //   icon: Workflow,
  //   color: "#16A34A",
  //   bg: "#DCFCE7",
  // },
  // "Avg Cost per Loan Applied Change": {
  //   icon: HandCoins,
  //   color: "#EF4444",
  //   bg: "#FEE2E2",
  // },
  // "Avg Cost per Loan Approved Change": {
  //   icon: TrendingDown,
  //   color: "#15803D",
  //   bg: "#DCFCE7",
  // },
  // "Avg Cost per Loan Disbursed Change": {
  //   icon: Percent,
  //   color: "#EC4899",
  //   bg: "#FCE7F3",
  // },
  // "Success Rate Change": {
  //   icon: Target,
  //   color: "#0284C7",
  //   bg: "#E0F2FE",
  // },
  // "Avg Cost Per Customer Change": {
  //   icon: AlertCircle,
  //   color: "#EF4444",
  //   bg: "#FEE2E2",
  // },
  //   "Failure Rate Change": {
  //   icon: Wallet,
  //   color: "#16A34A",
  //   bg: "#DCFCE7",
  // },
};
const stageMap = {
  LEAD_CREATED: { name: "Total Leads", color: "#1FB37C" },
  CREDIT_APPROVED: { name: "Credit Approval", color: "#3E7BE0" },
  OPS_VERIFIED: { name: "OPS Verified", color: "#5B6CFF" },
  AGREEMENT_SIGNED: { name: "Agreement Signed", color: "#7B61FF" },
  DISBURSED: { name: "Disbursed", color: "#9C4DFF" },
};

export default function OverView({
  leadStatus,
  admin,
  allStatus,
  handleBack,
  dateFilterPopup,
  setDateFilterPopup,
  dateType,
  setDateType,
  updateDateRange
}) {
  const [apiTracker, setAPiTracker] = useState(false);
  const [currentTab, setCurrentTab] = useState("apiwise");
  const [loader, setLoader] = useState(false);
  const [skeletonLoader, setSkeletonLoader] = useState(false);
  const [apiList, setApiList] = useState([]);
  const [apicategoryList, setapicategoryList] = useState([]);
  // const [currentSection, setCurrentSection] = useState("api");
  const [currentSection, setCurrentSection] = useState(CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE) ? "disbursed" : "api");

  const [chartData, setchartData] = useState([]);
  const [payload, setPayload] = useState({
    search: "",
    apiType: "",
    status: "",
  });

  const [filters, setFilters] = useState({
    type: "daily",
  });
  const [statsOption, setStatsOption] = useState({
    "Total API Hits": { value: "0", change: "-" },
    "Total API Cost": { value: "₹0", change: "-" },
    "Avg Cost per Loan Applied": { value: "₹0", change: "-" },
    "Cost Per Loan Approved": { value: "₹0", change: "-" },
    "Avg Cost Per Customer": { value: "₹0", change: "-" },
    "Success Rate": { value: "0%", change: "-" },
    "Avg Cost per Loan Disbursed": { value: "0", change: "-" },
    "Failure Rate": { value: "0%", change: "-" },
  });
  const [StepperData, setStepperData] = useState([]);
  const [tableData, setTableData] = useState({});
  // const [showAll, setShowAll] = useState(false);
  const [summaryFunnelData, setSummaryFunnelData] = useState();
  const [costPieChartData, setCostPieChartData] = useState();
  const [leadInsightsData, setLeadInsightsData] = useState();
  const [isFilterCleared, setIsFilterCleared] = useState(false);
  const [selectedCategory,setSelectedCategory] =useState("")

  const handleTab = (type) => {
    setCurrentTab(type);
  };
  const handleSection = (type) => {
    setCurrentSection(type);
    handleTab("apiwise");
  };

  const handlechange = (e, type) => {
    setPayload((prev) => ({
      ...prev,
      [type]: e.target.value,
    }));
  };

  const handleDateFilterPopup = (type, val) => {
    setDateFilterPopup((prev) => ({ ...prev, [type]: val }));
  };

  // const handleApplyDteFilter = () => {
  //   handleDateFilterPopup("show", false);
  // };
  const handleApplyFilter = () => {
    MainApi(dateFilterPopup);
    getApiHitTrendByDataRangeApiIdfn(dateFilterPopup);
  };
  const handleReset = () => {
    setPayload({
      search: "",
      apiType: "",
      status: "",
    });
    setIsFilterCleared(true);

    const today = moment();

    const resetDate = {
      show: false,
      from: today.clone().subtract(6, "days").format("YYYY-MM-DD"),
      to: today.format("YYYY-MM-DD"),
    };
    // setDateType('7')
    MainApi(resetDate);
    getApiHitTrendByDataRangeApiIdfn(resetDate);
  };

  // api calls
  // useEffect(() => {
  //   MainApi(dateFilterPopup);
  // }, []);
  useEffect(() => {
    if (dateFilterPopup?.from && dateFilterPopup?.to) {
      MainApi(dateFilterPopup);
    }
  }, [dateFilterPopup]);

  useEffect(() => {
    getApiHitTrendByDataRangeApiIdfn(dateFilterPopup);
  }, [filters]);

  const MainApi = (customDate) => {
    // getThirdPartyApiListByDatafn();
    getThirdPartyApiListcategoryWiseByDatafn();
    getApiOverallSummaryByDateStatusfn(customDate);

    getThirdParyHitDatafn(customDate);
    getLeadDisbursmentFunnelByDaterangefn(customDate);
    getApiOverviewLeadJourneyFunnelByDateRangeFn(customDate);
    getApiOverviewLeadLeakageInsightsByDateRangeFn(customDate);
  };

  const getLeadDisbursmentFunnelByDaterangefn = (customDate) => {
    const sDate = moment(customDate?.from)?.format("DD-MM-YYYY");
    const eDate = moment(customDate?.to)?.format("DD-MM-YYYY");
    setLoader(true);
    getLeadDisbursmentFunnelByDaterange(sDate, eDate, (callback) => {
      console.log("callback", callback);
      setLoader(false);
      setStepperData([
        {
          name: "Lead Created",
          value: callback?.data?.totalLeads ?? "-",
          subValue: "Leads",
          yellowBox: true,
        },
        {
          name: "Basic Information",
          value: getStatusCount(callback?.data?.formStatusStats, "Basic"),
          subValue: "Users",
          yellowBox: false,
        },
        {
          name: "KYC Verification",
          value: getStatusCount(
            callback?.data?.formStatusStats,
            "KYC Verification",
          ),
          subValue: "Users",
          yellowBox: false,
        },
        {
          name: "Employment Information",
          value: getStatusCount(
            callback?.data?.formStatusStats,
            "Eligibility Form",
          ),
          subValue: "Users",
          yellowBox: false,
        },
        {
          name: "Loan Information",
          value: getStatusCount(callback?.data?.formStatusStats, "Loan Offers"),
          subValue: "Users",
          yellowBox: false,
        },
        {
          name: "Selfie Verification",
          value: getStatusCount(callback?.data?.formStatusStats, "More Info"),
          subValue: "Users",
          yellowBox: false,
        },
        {
          name: "Account Details",
          value: getStatusCount(
            callback?.data?.formStatusStats,
            "Bank Details",
          ),
          subValue: "Users",
          yellowBox: false,
        },

        {
          name: "Documents",
          value: getStatusCount(callback?.data?.formStatusStats, "Documents"),
          subValue: "Users",
          yellowBox: false,
        },

        {
          name: "Reference Details",
          value: getStatusCount(
            callback?.data?.formStatusStats,
            "Loan Application",
          ),
          subValue: "Users",
          yellowBox: false,
        },
        {
          name: "Confirmation",
          value: getStatusCount(callback?.data?.formStatusStats, "Thanks"),
          subValue: "Users",
          yellowBox: false,
        },
        {
          name: "Disbursement",
          value: callback?.data?.disbursedLeads ?? "-",
          subValue: "Leads",
          yellowBox: true,
        },
      ]);
    });
  };

  // const getThirdPartyApiListByDatafn = () => {
  //   getThirdPartyApiListByData((callback) => {
  //     setApiList(callback?.data ?? {});
  //   });
  // };
  const getThirdPartyApiListcategoryWiseByDatafn = () => {
    getThirdPartyApiListcategoryWiseByData((callback) => {
      setapicategoryList(callback?.data ?? []);
    });
  };
  const getThirdParyHitDatafn = (customDate) => {
    const sDate = moment(customDate?.from)?.format("DD-MM-YYYY");
    const eDate = moment(customDate?.to)?.format("DD-MM-YYYY");
    getThirdParyHitData(sDate, eDate, (callback) => {
      setTableData(callback?.data ?? {});
    });
  };

  const getApiOverallSummaryByDateStatusfn = (customDate) => {
    const fetchData = async () => {
      try {
        setSkeletonLoader(true);

        const sDate = moment(customDate?.from)?.format("DD-MM-YYYY");
        const eDate = moment(customDate?.to)?.format("DD-MM-YYYY");

        const ar1 = await new Promise((resolve) => {
          getApicostSummaryByFilters(sDate, eDate, payload?.apiType, (res) => {
            resolve(res);
          });
        });

        const ar2 = await new Promise((resolve) => {
          getApicostSummaryHitsByFilters(
            sDate,
            eDate,
            payload?.status,
            payload?.apiType,
            (res) => {
              resolve(res);
            }
          );
        });

        setStatsOption({
          "Total API Hits": {
            value: ar2?.totalApiHits ?? "-",
            change: ar2?.totalApiHitsChange ?? "-",
          },
          "Total API Cost": {
            value: `₹${ar2?.totalApiCost ?? "-"}`,
            change: ar2?.totalApiCostChange ?? "-",
          },
          "Avg Cost per Loan Applied": {
            value: `₹${ar1?.avgCostPerLoanApplied ?? "-"}`,
            change: ar1?.avgCostPerLoanAppliedChange ?? "-",
          },
          "Cost Per Loan Approved": {
            value: `₹${ar1?.avgCostPerLoanApproved ?? "-"}`,
            change: ar1?.avgCostPerLoanApprovedChange ?? "-",
          },
          "Avg Cost Per Customer": {
            value: `₹${ar1?.avgCostPerCustomer ?? "-"}`,
            change: ar1?.avgCostPerCustomerChange ?? "-",
          },
          "Success Rate": {
            value: `${ar2?.successRate ?? "-"}%`,
            change: ar2?.successRateChange ?? "-",
          },
          "Avg Cost per Loan Disbursed": {
            value: `${ar1?.avgCostPerLoanDisbursed ?? "-"}`,
            change: ar1?.avgCostPerLoanDisbursedChange ?? "-",
          },
          "Failure Rate": {
            value: `${ar2?.failureRate ?? "-"}%`,
            change: ar2?.failureRateChange ?? "-",
          },
        });

      } catch (err) {
        console.error(err);
      } finally {
        setSkeletonLoader(false);
      }
    };

    fetchData()
   
    //   sDate,
    //   eDate,
    //   payload?.status,
    //   payload?.apiType,
    //   (callback) => {
    //     setStatsOption({
    //       "Total API Hits": {
    //         value: callback?.totalApiHits ?? "-",
    //         change: callback?.totalApiHitsChange ?? "-",
    //       },

    //       "Total API Cost": {
    //         value: `₹${callback?.totalApiCost ?? "-"}`,
    //         change: callback?.totalApiCostChange ?? "-",
    //       },

    //       "Avg Cost per Loan Applied": {
    //         value: `₹${callback?.avgCostPerLoanApplied ?? "-"}`,
    //         change: callback?.avgCostPerLoanAppliedChange ?? "-",
    //       },

    //       "Cost Per Loan Approved": {
    //         value: `₹${callback?.avgCostPerLoanApproved ?? "-"}`,
    //         change: callback?.avgCostPerLoanApprovedChange ?? "-",
    //       },

    //       "Avg Cost Per Customer": {
    //         value: `₹${callback?.avgCostPerCustomer ?? "-"}`,
    //         change: callback?.avgCostPerCustomerChange ?? "-",
    //       },

    //       "Success Rate": {
    //         value: `${callback?.successRate ?? "-"}%`,
    //         change: callback?.successRateChange ?? "-",
    //       },

    //       "Avg Cost per Loan Disbursed": {
    //         value: `${callback?.avgCostPerLoanDisbursed ?? "-"}`,
    //         change: callback?.avgCostPerLoanDisbursedChange ?? "-",
    //       },

    //       "Failure Rate": {
    //         value: `${callback?.failureRate ?? "-"}%`,
    //         change: callback?.failureRateChange ?? "-",
    //       },
    //     });
    //     setSkeletonLoader(false);
    //   },
    // );
  };
  const getApiHitTrendByDataRangeApiIdfn = (customDate) => {
    const sDate = moment(customDate?.from)?.format("DD-MM-YYYY");
    const eDate = moment(customDate?.to)?.format("DD-MM-YYYY");
    setLoader(true);
    getApiHitTrendByDataRangeApiId(
      sDate,
      eDate,
      filters?.type,
      payload?.apiType,
      (callback) => {
        setchartData(callback?.data?.data ?? []);
        setLoader(false);
      },
    );
  };

  const getApiOverviewLeadJourneyFunnelByDateRangeFn = (customDate) => {
    const sDate = moment(customDate?.from)?.format("DD-MM-YYYY");
    const eDate = moment(customDate?.to)?.format("DD-MM-YYYY");
    setLoader(true);
    getApiOverviewLeadJourneyFunnelByDateRange(sDate, eDate, (res) => {
      setLoader(false);
      setSummaryFunnelData(res?.data);
      setCostPieChartData(
        res?.data?.costDistribution?.map((item) => ({
          name: stageMap[item.stage]?.name || item.stage,
          value: item.percent,
          color: stageMap[item.stage]?.color || "#000",
        })),
      );
    });
  };

  const getApiOverviewLeadLeakageInsightsByDateRangeFn = (customDate) => {
    const sDate = moment(customDate?.from)?.format("DD-MM-YYYY");
    const eDate = moment(customDate?.to)?.format("DD-MM-YYYY");
    setLoader(true);
    getApiOverviewLeadLeakageInsightsByDateRange(sDate, eDate, (res) => {
      setLoader(false);
      setLeadInsightsData(res?.data);
    });
  };

  const hnadleOpenTracker = (val) => {
    setAPiTracker(val);
  };

  const data = [
    { name: "Total Leads", value: 28, color: "#1FB37C" },
    { name: "Disbursed", value: 10, color: "#9C4DFF" },
    { name: "Agreement Signed", value: 11, color: "#7B61FF" },
    { name: "OPS Verified", value: 11, color: "#5B6CFF" },
    { name: "Credit Approval", value: 17, color: "#3E7BE0" },
    { name: "KYC Completed", value: 23, color: "#1EA7B8" },
  ];

  const handleCategory = (e)=>{
    const val = e.target.value
    setSelectedCategory(val);
    const ar = apicategoryList && apicategoryList?.length > 0 ? apicategoryList?.filter((el)=> el?.category == val) : []
    setApiList(ar?.[0]?.apis ?? [])
  }

  const safeStats =
    statsOption && Object.keys(statsOption).length > 0
      ? statsOption
      : defaultStats;

  return (
    <>
      {loader ? <Loader /> : ""}
      <div className="OverView-Main-Section min-size-1800">
        <div className="topsTabs">
          <div className="leftTabs">
            <button
              className={`customTabsBtn ${currentTab == "apiwise" ? "active" : ""}`}
              onClick={() => handleTab("apiwise")}
            >
              API Wise
            </button>
            <button
              className={`customTabsBtn ${currentTab == "leadconversionState" ? "active" : ""}`}
              onClick={() => handleTab("leadconversionState")}
            >
              Lead Conversion Stat
            </button>
          </div>
          <div className="rightTabs">
            {currentTab == "apiwise" ? (
              <button
                className="rightSideBtn"
                onClick={() => hnadleOpenTracker(true)}
              >
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.35449 6.49984C1.35449 4.07407 1.35449 2.86119 2.10808 2.10759C2.86167 1.354 4.07456 1.354 6.50033 1.354C8.92607 1.354 10.139 1.354 10.8926 2.10759C11.6462 2.86119 11.6462 4.07407 11.6462 6.49984C11.6462 8.92558 11.6462 10.1385 10.8926 10.8921C10.139 11.6457 8.92607 11.6457 6.50033 11.6457C4.07456 11.6457 2.86167 11.6457 2.10808 10.8921C1.35449 10.1385 1.35449 8.92558 1.35449 6.49984Z"
                    stroke="#686C70"
                    stroke-width="0.8125"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.41699 8.396C5.41699 8.84471 5.05323 9.2085 4.60449 9.2085C4.15576 9.2085 3.79199 8.84471 3.79199 8.396C3.79199 7.94728 4.15576 7.5835 4.60449 7.5835C5.05323 7.5835 5.41699 7.94728 5.41699 8.396Z"
                    stroke="#686C70"
                    stroke-width="0.8125"
                  />
                  <path
                    d="M9.20801 4.604C9.20801 4.15527 8.84422 3.7915 8.39551 3.7915C7.94679 3.7915 7.58301 4.15527 7.58301 4.604C7.58301 5.05274 7.94679 5.4165 8.39551 5.4165C8.84422 5.4165 9.20801 5.05274 9.20801 4.604Z"
                    stroke="#686C70"
                    stroke-width="0.8125"
                  />
                  <path
                    d="M4.60449 7.58317V3.7915"
                    stroke="#686C70"
                    stroke-width="0.8125"
                    stroke-linecap="round"
                  />
                  <path
                    d="M8.39551 5.4165V9.20817"
                    stroke="#686C70"
                    stroke-width="0.8125"
                    stroke-linecap="round"
                  />
                </svg>
                API Configuration
              </button>
            ) : (
              ""
            )}
          </div>
        </div>

        {currentTab == "apiwise" ? (
          <>
            <div className="HeadingFilter-Section">
              <div
                style={{
                  marginTop: "15px",
                  // marginBottom: "15px",
                }}
              >
                <h4
                  onClick={(e) => handleBack(e)}
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    whiteSpace: "nowrap",
                    cursor: "pointer",
                  }}
                >
                  <ChevronLeft />
                  {currentSection == "api"
                    ? "API Overview (Applied Date)"
                    : currentSection == "users"
                      ? "Users List"
                      : currentSection == "disbursed"
                        ? "Disbursed (Disbursed Date)"
                        : currentSection == "aggregator"
                          ? "Aggregator"
                          : currentSection == "sanction"
                            ? "Sanction (Apply Date)"
                            : ""}
                </h4>
              </div>
              <div className="customBtnops">
                {!CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE) ? <button
                  className={`customBtns ${currentSection == "api" ? "active" : ""}`}
                  onClick={() => handleSection("api")}
                >
                  API
                </button> : ""}
                {/* <button
                  className={`customBtns ${currentSection == "users" ? "active" : ""}`}
                  onClick={() => handleSection("users")}
                >
                  Users
                </button>
                <button
                  className={`customBtns ${currentSection == "disbursed" ? "active" : ""}`}
                  onClick={() => handleSection("disbursed")}
                >
                  Disbursed
                </button>
                <button
                  className={`customBtns ${currentSection == "aggregator" ? "active" : ""}`}
                  onClick={() => handleSection("aggregator")}
                >
                  Aggregator
                </button> */}
                <button
                  className={`customBtns ${currentSection == "disbursed" ? "active" : ""}`}
                  onClick={() => handleSection("disbursed")}
                >
                  Disbursed
                </button>
                <button
                  className={`customBtns ${currentSection == "sanction" ? "active" : ""}`}
                  onClick={() => handleSection("sanction")}
                >
                  Sanction
                </button>
              </div>
            </div>
            {currentSection == "api" && (
              <div className="HeadingFilter-main-filters">
                <div className="row">
                  <div
                    className="col-xl-9 col-lg-10 col-xs-12"
                    style={{ display: "flex", gap: "10px", marginTop: "5px" }}
                  >
                    {/* <div className='customInputSearch-bar' style={{ width: window.innerWidth > 1200 ? '35%' : "auto" }}>
                            <i className='fa fa-search'></i>
                            <input placeholder='Search' className='customInput' value={payload?.search} onChange={(e) => handlechange(e, "search")} />
                          </div> */}
                    <select
                      className="customSelectBox"
                      value={selectedCategory}
                      onChange={(e) => handleCategory(e)}
                    >
                      <option value="">Select Api Category</option>
                        {console.log("apicategoryList",apicategoryList)}
                     {apicategoryList && apicategoryList.length > 0 &&
    apicategoryList.map((val, id) => (
      <option key={id} value={val?.category}>
        {val?.category?.charAt(0)?.toUpperCase() + val?.category?.slice(1)}
      </option>
    ))
  }
                    </select>
                    <select
                      className="customSelectBox"
                      value={payload?.apiType}
                      onChange={(e) => handlechange(e, "apiType")}
                    >
                      <option value="">Select Api</option>

                      {apiList && apiList?.length > 0
                        ? apiList?.map((val, id) => {
                          return (
                            <option value={val?.apiId}>{val?.apiName}</option>
                          );
                        })
                        : ""}
                    </select>
                    <select
                      className="customSelectBox"
                      value={payload?.status}
                      onChange={(e) => handlechange(e, "status")}
                    >
                      <option value="">Select Status</option>
                      {leadStatus?.length > 0
                        ? leadStatus?.map((val, id) => {
                          return (
                            <option value={val?.statusId}>
                              {val?.adminStatus}
                            </option>
                          );
                        })
                        : ""}
                    </select>
                    <DateFilterSelect
                      onChange={(range) => {
                        updateDateRange(range[0], range[1], "custom");
                      }}
                      dateFilterPopup={dateFilterPopup}
                      type={dateType}
                      onTypeChange={setDateType}
                      isFilterCleared={isFilterCleared}
                    />

                    {/* <div className="custom-popup" style={{ width: "25%" }}>
                      <div
                        className="customSelectBox "
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          gap: "20px",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          handleDateFilterPopup("show", !dateFilterPopup?.show)
                        }
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: "7px",
                            alignItems: "center",
                          }}
                        >
                          <svg
                            width="9"
                            height="9"
                            viewBox="0 0 9 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6 0.75V2.25M3 0.75V2.25"
                              stroke="#0C0B10"
                              stroke-width="0.5625"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M4.875 1.5H4.125C2.71079 1.5 2.00368 1.5 1.56434 1.93934C1.125 2.37868 1.125 3.08579 1.125 4.5V5.25C1.125 6.6642 1.125 7.37134 1.56434 7.81065C2.00368 8.25 2.71079 8.25 4.125 8.25H4.875C6.2892 8.25 6.99634 8.25 7.43565 7.81065C7.875 7.37134 7.875 6.6642 7.875 5.25V4.5C7.875 3.08579 7.875 2.37868 7.43565 1.93934C6.99634 1.5 6.2892 1.5 4.875 1.5Z"
                              stroke="#0C0B10"
                              stroke-width="0.5625"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M1.125 3.75H7.875"
                              stroke="#0C0B10"
                              stroke-width="0.5625"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          {dateFilterPopup?.from && dateFilterPopup?.to
                            ? `${moment(dateFilterPopup?.from).format("DD MMM YYYY")} - ${moment(dateFilterPopup?.to).format("DD MMM YYYY")}`
                            : "Select Date Range"}
                        </div>
                        <div style={{ marginTop: "-5px" }}>
                          <svg
                            width="8"
                            height="4"
                            viewBox="0 0 8 4"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.375 0.375025C7.375 0.375025 4.79731 3.375 3.875 3.375C2.95263 3.375 0.375 0.375 0.375 0.375"
                              stroke="#686C70"
                              stroke-width="0.75"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                      {dateFilterPopup?.show ? (
                        <CustomDateFilter
                          payload={dateFilterPopup}
                          handlechange={handleDateFilterPopup}
                          handleApply={handleApplyDteFilter}
                        />
                      ) : (
                        ""
                      )}
                    </div> */}
                  </div>
                  <div
                    className="col-xl-3 col-lg-2 col-xs-12"
                    style={{ marginTop: "5px" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        justifyContent:
                          window.innerWidth > 1200 ? "end" : "start",
                      }}
                    >
                      <div className="custom-btn" onClick={handleApplyFilter}>
                        <i
                          class="fa fa-filter"
                          style={{
                            fontSize: window.innerWidth >= 1800 ? "20px" : "",
                          }}
                          aria-hidden="true"
                        ></i>
                      </div>
                      {/* <div className="custom-btn">
                        <i
                          class="fa fa-download"
                          style={{
                            fontSize: window.innerWidth >= 1800 ? "20px" : "",
                          }}
                          aria-hidden="true"
                        ></i>
                      </div> */}
                      <div className="custom-btn" onClick={handleReset}>
                        <i
                          class="fa fa-times"
                          style={{
                            fontSize: window.innerWidth >= 1800 ? "20px" : "",
                          }}
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <>
              {currentSection == "api" ? (
                <div style={{ margin: window.innerWidth > 1800 ? "50px" : "" }}>
                  {/* <div style={{ marginTop: customMargin }}>
                   
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(4,1fr)",
                        gap: "20px",
                      }}
                    >
                      {Object.entries(statsOption)?.map(([key, val], i) => {
                        const item = statsConfig[key];
                        const Icon = item?.icon;

                        return (
                          <div
                            key={i}
                            style={{
                              border: "1px solid #E5E7EB",
                              borderRadius: "14px",
                              padding: "22px",
                              background: "#fff",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <div>
                                <p
                                  style={{
                                    color: "#6B7280",
                                    fontSize: "15px",
                                    marginBottom: 0,
                                  }}
                                >
                                  {key}
                                </p>

                                <h2
                                  style={{
                                    fontSize: "24px",
                                    fontWeight: 500,
                                    marginTop: 10,
                                  }}
                                >
                                  {val?.value}
                                </h2>

                                <p
                                  style={{
                                    marginTop: 10,
                                    fontSize: 14,
                                    marginBottom: "0px",
                                  }}
                                >
                                  <span
                                    style={{
                                      color:
                                        val?.change >= 0
                                          ? "#16A34A"
                                          : "#EF4444",
                                      fontWeight: 500,
                                    }}
                                  >
                                    {val?.change !== "-"
                                      ? `${val?.change}%`
                                      : "-"}
                                  </span>
                                  <span
                                    style={{
                                      color: "#6B7280",
                                      marginLeft: 5,
                                    }}
                                  >
                                    vs Previous Period
                                  </span>
                                </p>
                              </div>

                              <div
                                style={{
                                  background: item?.bg,
                                  padding: 10,
                                  borderRadius: 10,
                                  height: "fit-content",
                                }}
                              >
                                {Icon && <Icon size={22} color={item?.color} />}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div> */}

                  <div style={{ marginTop: customMargin }}>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(4,1fr)",
                        gap: "20px",
                      }}
                    >
                      {/* ✅ Loader State */}
                      {skeletonLoader
                        ? Array.from({ length: 8 }).map((_, i) => (
                          <SkeletonCard key={i} />
                        ))
                        : Object.entries(safeStats).map(([key, val], i) => {
                          const item = statsConfig[key];
                          const Icon = item?.icon;

                          const isValueDash =
                            val?.value === "-" || val?.value === undefined;

                          return (
                            <div
                              key={i}
                              style={{
                                border: "1px solid #E5E7EB",
                                borderRadius: "14px",
                                padding: "22px",
                                background: "#fff",
                                opacity:
                                  !statsOption ||
                                    Object.keys(statsOption).length === 0
                                    ? 0.7
                                    : 1,
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div>
                                  <p
                                    style={{
                                      color: "#6B7280",
                                      fontSize: "15px",
                                      marginBottom: 0,
                                    }}
                                  >
                                    {key}
                                  </p>

                                  <h2
                                    style={{
                                      fontSize: "24px",
                                      fontWeight: 500,
                                      marginTop: 10,
                                    }}
                                  >
                                    {isValueDash ? "00" : val?.value}
                                  </h2>

                                  <p
                                    style={{
                                      marginTop: 10,
                                      fontSize: 14,
                                      marginBottom: 0,
                                    }}
                                  >
                                    <span
                                      style={{
                                        color:
                                          val?.change === "-"
                                            ? "#6B7280"
                                            : val?.change >= 0
                                              ? "#16A34A"
                                              : "#EF4444",
                                        fontWeight: 500,
                                      }}
                                    >
                                      {val?.change !== "-"
                                        ? `${val?.change}%`
                                        : "-"}
                                    </span>

                                    <span
                                      style={{
                                        color: "#6B7280",
                                        marginLeft: 5,
                                      }}
                                    >
                                      vs Previous Period
                                    </span>
                                  </p>
                                </div>

                                <div
                                  style={{
                                    background: item?.bg,
                                    padding: 10,
                                    borderRadius: 10,
                                    height: "fit-content",
                                  }}
                                >
                                  {Icon && (
                                    <Icon size={22} color={item?.color} />
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                  <div style={{ marginTop: customMargin }}>
                    <CustomStepper Data={StepperData} />
                  </div>
                  <div style={{ marginTop: customMargin }}>
                    <LeadFunnel
                      data={summaryFunnelData?.funnel}
                      customDate={dateFilterPopup}
                    />
                  </div>

                  <div style={{ marginTop: customMargin }}>
                    <LeakageInsights data={leadInsightsData} />
                  </div>

                  <div className="row">
                    <div
                      className="col-sm-7 col-xs-12"
                      style={{ marginTop: customMargin }}
                    >
                      <BarChartsMain
                        barcolor={"#a86cf8"}
                        xAxisDataKey={"stage"}
                        barData={summaryFunnelData?.funnel?.map((item) => ({
                          ...item,
                          stage: item.stage
                            .replace(/_/g, " ")
                            .toLowerCase()
                            .replace(/\b\w/g, (c) => c.toUpperCase()),
                        }))}
                        yAxisLabel={"expenses"}
                        heading={"Stage-wise Cost Distribution"}
                        className={"common-heading"}
                        angelTilt={0}
                        xaxis="middle"
                      />
                    </div>

                    <div
                      className="col-sm-5 col-xs-12"
                      style={{
                        border: "1px solid #ddd",
                        borderRadius: "10px",
                        padding: "20px",
                        // width: "100%",
                        height: "320px",
                        background: "white",
                        marginTop: customMargin,
                      }}
                    >
                      <h5
                        style={{
                          fontSize: window.innerWidth >= 1800 ? "20px" : "14px",
                        }}
                      >
                        Cost Distribution by Stage
                      </h5>

                      <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                          <Tooltip
                            formatter={(value, name) => [`${value}%`, name]}
                            contentStyle={{
                              borderRadius: "8px",
                              border: "1px solid #eee",
                            }}
                          />

                          <Pie
                            data={costPieChartData}
                            innerRadius={70}
                            outerRadius={100}
                            paddingAngle={4}
                            dataKey="value"
                            label={({ name, value }) => `${name}: ${value}%`}
                            labelLine={false}
                          >
                            {data.map((entry, index) => (
                              <Cell key={index} fill={entry.color} />
                            ))}
                          </Pie>
                        </PieChart>
                      </ResponsiveContainer>
                    </div>
                  </div>


                  {/* <div className="container"> */}
                  <div className="row" style={{ marginTop: customMargin }}>
                    <div className="col-lg-4 col-xs-12">
                      <div>
                        <AreaChart
                          showFilters={true}
                          heading={"API Hit Trends"}
                          AreaData={chartData}
                          xDataKeyName={
                            filters?.type === "daily"
                              ? "date"
                              : filters?.type === "weekly"
                                ? "weekName"
                                : "monthName"
                          }
                          DataKeyName={"totalHits"}
                          colorType={"green"}
                          showSelectBox={false}
                          setFilters={setFilters}
                          chartFilterValues={filters}
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-xs-12">
                      <div>
                        <AreaChart
                          showFilters={true}
                          heading={"API Cost Trends"}
                          AreaData={chartData}
                          xDataKeyName={
                            filters?.type === "daily"
                              ? "date"
                              : filters?.type === "weekly"
                                ? "weekName"
                                : "monthName"
                          }
                          DataKeyName={"totalCost"}
                          colorType={"blue"}
                          showSelectBox={false}
                          setFilters={setFilters}
                          chartFilterValues={filters}
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-xs-12">
                      <div>
                        <BarMixedCharts
                          showFilters={true}
                          heading={"Success vs Failure Trend"}
                          AreaData={chartData}
                          xDataKeyName={
                            filters?.type === "daily"
                              ? "date"
                              : filters?.type === "weekly"
                                ? "weekName"
                                : "monthName"
                          }
                          BarDataKeyName={"failureRate"}
                          LineDataKeyName={"successRate"}
                          colorType={"purpleishRed"}
                          chartHeight={285}
                          LegendLeft={"Failed Hits"}
                          LegendRight={"Success Hits"}
                          showSelectBox={false}
                          setFilters={setFilters}
                          chartFilterValues={filters}
                        />
                      </div>
                    </div>
                  </div>

                  <div
                    className="row"
                    style={{
                      marginTop: customMargin,
                    }}
                  >
                    <div className="col-xs-12">
                      <div className="customDash-table">
                        <div>
                          <h5>API-Wise Detailed Table</h5>
                        </div>
                        <div className="main-customized-table">
                          <table className="table">
                            <thead>
                              <tr>
                                <th>API Name</th>
                                <th>Hits</th>
                                <th>Success Hits</th>
                                {/* successTd */}
                                <th>Failed Hits</th>
                                <th>Success%</th>
                                <th>Cost Per Hit</th>
                                <th>Total Cost</th>
                                <th>Response Time (Avg/Max)</th>
                                <th>Vendor</th>
                                {/* <th>SLA Status</th>
                                  <th>Error Codes</th>
                                  <th>Impacted Users</th> */}
                              </tr>
                            </thead>
                            <tbody>
                              {Object.keys(tableData).length > 0 &&
                                Object.entries(tableData).map(
                                  ([vendorName, apis]) =>
                                    Object.entries(apis).map(
                                      ([apiName, apiData], index) => {
                                        return (
                                          <tr
                                            key={`${vendorName}-${apiName}-${index}`}
                                          >
                                            <td>{apiName}</td>
                                            <td>{apiData?.hitCount}</td>
                                            <td>{apiData?.successCount}</td>
                                            <td>{apiData?.failureCount}</td>
                                            <td>
                                              <div
                                                className="successTd"
                                                style={{
                                                  display: "inline-block",
                                                  padding: "5px 10px",
                                                  borderRadius: "6px",
                                                }}
                                              >
                                                {apiData?.successPercentage?.toFixed(
                                                  2,
                                                )}
                                              </div>
                                            </td>
                                            <td>{apiData?.costing}</td>
                                            <td>{apiData?.apiCost}</td>
                                            <td>{apiData?.avgTat}</td>
                                            <td>{vendorName}</td>
                                          </tr>
                                        );
                                      },
                                    ),
                                )}
                              {/* <tr>
                            <td><div className='successTd'>PI Nam</div></td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                          </tr> */}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* </div> */}
                </div>
              ) : (
                ""
              )}
            </>

            {currentSection == "users" ? <Users /> : ""}
            {currentSection == "disbursed" ? (
              <Disbursed
                updateDateRange={updateDateRange}
                dateFilterPopup={dateFilterPopup}
                handleDateFilterPopup={handleDateFilterPopup}
                dateType={dateType}
                setDateType={setDateType}
              />
            ) : (
              ""
            )}
            {currentSection == "aggregator" ? <Aggregator /> : ""}
            {currentSection == "sanction" ? (
              <Sanction
                dateFilterPopup={dateFilterPopup}
                handleDateFilterPopup={handleDateFilterPopup}
                dateType={dateType}
                setDateType={setDateType}
              />
            ) : (
              ""
            )}
          </>
        ) : (
          ""
        )}

        {currentTab == "leadconversionState" ? (
          <LeadConversionStat
            dateFilterPopup={dateFilterPopup}
            handleDateFilterPopup={handleDateFilterPopup}
            dateType={dateType}
            setDateType={setDateType}
            updateDateRange={updateDateRange}
          />
        ) : (
          ""
        )}

        {apiTracker ? (
          <div className="custom-full-screenPopup">
            <div className="main-content-popup">
              <button
                className="custm-close-btn"
                onClick={() => hnadleOpenTracker(false)}
              >
                X
              </button>
              <MainApiComponent admin={admin} allStatus={allStatus} />
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
}

const shimmerStyle = {
  background: "linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 37%, #f3f4f6 63%)",
  backgroundSize: "400% 100%",
  animation: "shimmer 1.4s ease infinite",
  borderRadius: "6px",
};

const SkeletonCard = () => {
  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
    @keyframes shimmer {
      0% { background-position: 100% 0; }
      100% { background-position: 0 0; }
    }
  `;
    document.head.appendChild(style);
  }, []);
  return (
    <div
      style={{
        border: "1px solid #E5E7EB",
        borderRadius: "14px",
        padding: "22px",
        background: "#fff",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ flex: 1 }}>
          <div
            style={{
              ...shimmerStyle,
              height: "12px",
              width: "60%",
              marginBottom: "10px",
            }}
          />
          <div
            style={{
              ...shimmerStyle,
              height: "24px",
              width: "40%",
              margin: "12px 0",
            }}
          />
          <div
            style={{
              ...shimmerStyle,
              height: "12px",
              width: "80%",
              marginBottom: "10px",
            }}
          />
        </div>

        <div
          style={{
            width: 42,
            height: 42,
            borderRadius: 10,
            background: "#e5e7eb",
          }}
        />
      </div>
    </div>
  );
};

// const SkeletonCard = () => {
//   return (
//     <div
//       style={{
//         border: "1px solid #E5E7EB",
//         borderRadius: "14px",
//         padding: "22px",
//         background: "#fff",
//       }}
//     >
//       <div style={{ display: "flex", justifyContent: "space-between" }}>
//         <div style={{ flex: 1 }}>
//           <div className="sk sk-text" style={{ width: "60%" }} />
//           <div className="sk sk-title" />
//           <div className="sk sk-text" style={{ width: "80%" }} />
//         </div>

//         <div
//           className="sk sk-icon"
//           style={{
//             width: 42,
//             height: 42,
//             borderRadius: 10,
//           }}
//         />
//       </div>
//     </div>
//   );
// };
